<template>
  <div class="container">
    <h1>
      <Translation name="homepage.title" default="Hello World" />
    </h1>
    <h2>
      <Translation
        name="homepage.getting_started"
        default="This is your Vue.js app"
      />
    </h2>
    <button @click="count++" class="px-8 py-1 bg-my-blue rounded">
      {{ count }}
    </button>
  </div>
</template>

<script setup>
import { ref } from "vue";

const count = ref(0);
</script>

<style scoped>
h1 {
  color: blue;
}
</style>
